// @flow
import { storedSession } from 'common/services/StoredSession';

const useClientIdFromCookie = (): ?string => {
    return storedSession.clientId;
};

export default useClientIdFromCookie;
